<template>
  <m-dialog ref="dlg" :action="false" title="Hubungkan Tenant">
    <v-container class="px-10">
      <v-card class="pa-5 mb-2">
        <v-card-text>
          <div>
            <div class="text-h6 primary--text font-weight-regular"> Kode Tenant </div>
            <div class="body-1 black--text font-weight-regular">
              Mutasi pegawai antar tenant dapat dilakukan dengan menginputkan kode tenant yang sesuai pada sistem. Kode
              tenant tersebut harus valid dan terdaftar dalam database sistem untuk dapat memproses permintaan mutasi.
            </div>
          </div>
        </v-card-text>
      </v-card>

      <m-card-list
        two-line
        title="Tenant"
        :items="items"
        footer
        search
        :page="page"
        :add="false"
        @search="
          (search) => {
            keyword = search
            load()
          }
        "
        @change:page="
          (pg) => {
            cp = pg
            load()
          }
        "
      >
        <template v-slot:items="{ props, item }">
          <tr>
            <td style="width: 40%">
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar :size="40" color="grey lighten-4">
                    <img :src="item.file_foto || 'img/organisasi-default.png'" alt="avatar" />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div> {{ pVal(item, 'nama') }}</div>
                  <div class="caption grey--text">{{ pVal(item, 'email') }}</div>
                </v-list-item-content>
              </v-list-item>
            </td>
            <td>
              <div class="grey--text caption"> Tenant ID</div>
              <div class="primary--text mt-n1 body-1"> {{ pVal(item, 'no_reg') }} </div>
            </td>
            <td>
              <template v-if="Number(getDeepObj(item, 'is_connected')) === 1">
                <v-btn depressed outlined color="primary" @click="onCancelConnect(item)"
                  ><v-icon left>mdi-link-off</v-icon> Terhubung</v-btn
                >
              </template>
              <template v-else>
                <v-btn depressed color="primary" @click="onConnect(item)"
                  ><v-icon left>mdi-link</v-icon> Hubungkan</v-btn
                >
              </template>
            </td>
          </tr>
        </template>
      </m-card-list>
    </v-container>
  </m-dialog>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      cp: 1,
      page: {},
      keyword: '',
    }
  },
  methods: {
    open() {
      this.$refs.dlg.open()
      this.load()
    },

    load() {
      this.$store
        .dispatch('tenant/getKoneksi', { no_reg: this.current_user.kode_tenant, params: { is_semua: 1 } })
        .then((resp) => {
          this.page = resp.data || {}
          this.items = resp.data.data || []
        })
    },

    onConnect(item) {
      this.$confirm(`Apakah Anda ingin koneksi ke Tenant <b>${item.nama}</b> ?`, {}, 'Koneksi ke Tenant').then(() => {
        this.$store
          .dispatch('tenant/setKoneksi', {
            no_reg: this.current_user.kode_tenant,
            api: 'koneksi',
            params: { tenant_id: item.tenant_id },
          })
          .then(() => {
            this.$success('Koneksi Berhasil')
            this.load()
            this.$emit('reload')
          })
      })
    },

    onCancelConnect(item) {
      this.$confirmDanger(
        `Apakah Anda ingin membatalkan koneksi ke Tenant <b>${item.nama}</b> ?`,
        { color: 'red' },
        'Batalkan Koneksi'
      ).then(() => {
        this.$store
          .dispatch('tenant/setKoneksi', {
            no_reg: this.current_user.kode_tenant,
            api: 'putus-koneksi',
            params: { tenant_id: item.tenant_id },
          })
          .then(() => {
            this.$success('Koneksi Berhasil Dibatalkan')
            this.load()
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
